var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyPentugramGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_156_4198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11C2.5 5.75329 6.75329 1.5 12 1.5H48C53.2467 1.5 57.5 5.75329 57.5 11V47C57.5 52.2467 53.2467 56.5 48 56.5H12C6.75329 56.5 2.5 52.2467 2.5 47V11Z",
    stroke: "#F3F3F6",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 33.8957C32.7052 33.8957 34.8982 31.7027 34.8982 28.9975C34.8982 26.2924 32.7052 24.0994 30 24.0994C27.2948 24.0994 25.1018 26.2924 25.1018 28.9975C25.1018 31.7027 27.2948 33.8957 30 33.8957Z",
    stroke: "#3070CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1751 31.858V26.142H40.5813C40.3367 25.2307 39.9748 24.3551 39.5047 23.537L42.7513 20.2904L38.7097 16.2487L35.463 19.4954C34.6448 19.0238 33.7692 18.6594 32.858 18.4112V13.825H27.142V18.4112C26.231 18.6593 25.3558 19.0237 24.5378 19.4954L21.2904 16.2487L17.2487 20.2904L20.4954 23.537C20.0255 24.3551 19.6639 25.2308 19.4196 26.142H14.825V31.858H19.4196C19.6639 32.769 20.0255 33.6444 20.4954 34.4622L17.2487 37.7088L21.2904 41.7513L24.5378 38.5038C25.3556 38.976 26.2309 39.3407 27.142 39.5888V44.1751H32.858V39.5888C33.7693 39.3405 34.6449 38.9758 35.463 38.5038L38.7097 41.7513L42.7513 37.7088L39.5047 34.4622C39.9748 33.6444 40.3367 32.769 40.5813 31.858H45.1751Z",
    stroke: "#3070CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_156_4198",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_156_4198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_156_4198",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyPentugramGear);
export default __webpack_public_path__ + "static/media/why-pentugram-gear.d4f4d7f24446a451e2b9ef09f44a2e75.svg";
export { ForwardRef as ReactComponent };